<template>
  <div class="card-container">
    <div class="container1">
      <v-row class="align-center mb-5">
        <v-col cols="12" class="text-center">
          <h3>{{ getSeguradoraNome }}</h3>
        </v-col>
        <!-- <v-col class="text-right pr-1">
          <v-tooltip bottom content-class="tooltip-label-form">
            <template v-slot:activator="{ on }">
              <v-icon class="pl-1" color="secondary" size="12" v-on="on">
                fa-info-circle
              </v-icon>
            </template>
            <v-row>
              <v-col cols="12" class="px-4 py-3">
                <p class="white--text tooltip-label-text mb-0">
                  Conforme previsto pela SUSEP os prazos das cotações tem
                  vigência máxima de 15 dias. Após esse período as seguradoras
                  se reservam no direito de retirar e/ou revisar as condições
                  propostas nas minutas
                </p>
              </v-col>
            </v-row>
          </v-tooltip>
        </v-col> -->
      </v-row>
      <v-divider class="pb-6" />
      <v-row class="pb-3">
        <v-col class="text-left" cols="7">Tipo de Seguro</v-col>
        <v-col class="text" cols="5">
          {{ getTipoSeguro }}
        </v-col>
      </v-row>
      <v-row class="pb-2">
        <v-col class="text-left" cols="7">Cobertura</v-col>
        <v-col class="text">
          {{ getCobertura }}
        </v-col>
      </v-row>
      <v-row class="pb-2">
        <v-col class="text-left" cols="7">Área segurada</v-col>
        <v-col class="text"> {{ asNumberString(getAreaSegurada) }} ha </v-col>
      </v-row>
      <v-row class="pb-2">
        <v-col class="text-left" cols="7">Produtividade Garantida</v-col>
        <v-col class="text">
          {{ asNumberString(getProdutividadeGarantida) }} saca/ha
        </v-col>
      </v-row>
      <v-row class="pb-2">
        <v-col class="text-left" cols="7">Custo por hectare</v-col>
        <v-col class="text"> R$ {{ asNumberString(getCustoHectare) }} </v-col>
      </v-row>
      <v-row class="pb-2">
        <v-col class="text-left" cols="7">Importância Segurada</v-col>
        <v-col class="text">
          R$ {{ asNumberString(getImportanciaSegurada) }}
        </v-col>
      </v-row>
      <v-row class="row-collor-blue pb-1 pt-1">
        <v-col class="text-left" cols="7">Preço Total</v-col>
        <v-col class="text"> R$ {{ asNumberString(getPrecoTotal) }} </v-col>
      </v-row>
      <v-row class="pt-1 pb-1 row-collor-yellow">
        <v-col class="text-left" cols="7">Subvenção Federal</v-col>
        <v-col class="text"> R$ {{ asNumberString(getSubFederal) }} </v-col>
      </v-row>
      <v-row class="pt-1 pb-1 row-collor-yellow">
        <v-col class="text-left" cols="7">Subvenção Estadual</v-col>
        <v-col class="text"> R$ {{ asNumberString(getSubEstadual) }} </v-col>
      </v-row>
      <v-row class="row-collor-blue pt-1 pb-1">
        <v-col class="text-left" cols="7">Preço do Segurado</v-col>
        <v-col class="text"> R$ {{ asNumberString(getPrecoSegurado) }} </v-col>
      </v-row>
      <v-row class="align-center justify-center pt-6" v-if="showButton">
        <BaseButton
          v-html="'CONTRATAR'"
          class="buttonContract no-print"
          outlined
          @click="handleClick(item)"
        >
        </BaseButton>
      </v-row>
    </div>
  </div>
</template>
<script>
import { asNumberString } from "@/utils/formats.js";
import BaseButton from "../../../components/base/BaseButton.vue";
export default {
  components: { BaseButton },
  props: {
    item: Object,
    index: Number,
    showButton: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      asNumberString
    };
  },
  computed: {
    getSeguradoraNome() {
      return this.item.insuranceCompany?.nome ?? this.item.seguradora?.nome;
    },
    getTipoSeguro() {
      return this.item.insuranceType?.nome ?? this.item.tipo_seguro?.name;
    },
    getCobertura() {
      return this.item.coverage?.nome ?? this.item.tipo_cobertura?.name;
    },
    getAreaSegurada() {
      return this.item.insuredArea ?? this.item.area_segurada;
    },
    getProdutividadeGarantida() {
      return this.item.grantedProduction ?? this.item.producao_garantida;
    },
    getCustoHectare() {
      return this.item.hectareCost ?? this.item.custo_por_hectare;
    },
    getImportanciaSegurada() {
      return this.item.insuredValue ?? this.item.importancia_segurada;
    },
    getPrecoTotal() {
      return this.item.total ?? this.item.custo_total;
    },
    getSubFederal() {
      return this.item.federalSubvention ?? this.item.subvencao_federal;
    },
    getSubEstadual() {
      return this.item.stateSubvention ?? this.item.subvencao_estadual;
    },
    getPrecoSegurado() {
      return this.item.insuredPrice ?? this.item.custo_segurado;
    }
  },
  methods: {
    handleClick() {
      this.$emit("open-payment", this.item);
    }
  }
};
</script>
<style lang="sass">
.cardContainer
  margin-top: 30px
.container1
  font-size: 12px
  border: 1px solid #d5d5e0
  padding-top: 20px
  padding-bottom: 20px
  letter-spacing: 0.5px
  width: 320px !important
.text-left
  font-weight: 700
  padding-left: 5px
.text-center
  font-weight: 700
.text
  font-weight: 600
  padding-left: 1px
.row-collor-blue
  background: #6b8ae6
.row-collor-yellow
  background-color: #e3e3ee
  margin-top: 4px
  margin-bottom: 4px
.buttonContract
  color: blue
  cursor: pointer
@media print
  .no-print
    display: none
  .container1
    font-size: 8px !important
    padding: 0px !important
    margin: 1px !important
    width: auto !important
    padding-top: 10px !important
</style>
